import { render, staticRenderFns } from "./MessageHistory.vue?vue&type=template&id=9eecafae&scoped=true"
import script from "./MessageHistory.vue?vue&type=script&lang=js"
export * from "./MessageHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eecafae",
  null
  
)

export default component.exports